import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// A questionnaire's questions by what they carry (comments, attachments), in
// its answer view. The options (with counts) come from the questions on the page.
export const QuestionContainsFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTION_CONTAINS}
      filterName={FilterName.QUESTION_CONTAINS}
      valueKey="questionContains"
      isNested={isNested}
    />
  ),
)
